<script>
  import config from './config.js'
  import {ann, geo2data} from './stores.js'
  import isNumeric from './helpers/isnumeric.js'
  import tract2town from './helpers/tract2town.js'

  export var moe
  export var prefix
  export var suffix

  // For the map on the right
  export var positiveIncrease

  var color, before, after, beforemoe, aftermoe, percentchange;

  $: if ($geo2data[$ann]) {
    before = $geo2data[$ann]['before'].toLocaleString();
    beforemoe = $geo2data[$ann]['beforemoe'].toLocaleString();
    after = $geo2data[$ann]['after'].toLocaleString();
    aftermoe = $geo2data[$ann]['aftermoe'].toLocaleString();

    percentchange = $geo2data[$ann]['percentchange'];

    color = (percentchange > 0 && positiveIncrease)
      || (percentchange < 0 && !positiveIncrease) ? 'purple' : 'orange';
    color = percentchange ==  0 ? 'black' : color;
    
  }
</script>

<div class="w-100 tc cf" style="margin-top: -140px; height: 300px;">
  {#if $ann}
    <p class="f6 black-80"> ACS 2013 &rarr; ACS 2018 </p>
    <p class="f4 mt0 mb1">
      {$geo2data[$ann]['geotype'] === 'tract' ? 'Census tract ' : ''}
      {$ann}
      {$geo2data[$ann]['geotype'] === 'tract' ? '(' + tract2town[$ann].Town + ')' : ''}
    </p>
    
    <p class="f3 mv0 black-50">
      <span class="black">{prefix}{before}</span>
      {#if moe}
        <span class="f6"> &pm; {beforemoe} </span>
      {/if}
      <span class="f6">{suffix}</span>
      &rarr;
      <span class="{color}">{prefix}{after}</span>
      {#if moe}
        <span class="f6"> &pm; {aftermoe} </span>
      {/if}
      <span class="f6">{suffix}</span>
      <br>
      <span class="f5 {color}"> ({percentchange > 0 ? '+' : ''}{percentchange}%) </span>
    </p>
  {/if}
</div>
